import * as React from 'react';
import { EMPTY_TEXT } from '@mitchell/react.component.ux';
import { EnterpriseDocStoreService, TranslationService } from "../../../common";
import { VehicleAttributeContainer } from "../../../vehicleAttribute";
import { VehicleInfoState, VehicleSelectionContainer, VehicleSelectionMethod } from "../../../vehicleInfo";
import { IntelligentAssignmentSummary, IntelligentPhotoCaptureAddViewConstants, OCR_previewScreen_RegEx_validator, VIN_INVALID_MESSAGE } from '../../constants';
import { IntelligentPhotoCaptureViewType } from '../../enums';
import { attachmentInfo as attachmentInfoUtilities, getEstimatorSummaryHeaderText, vinDecode } from '../../utilities';
import { StyledImageDiv, StyledVehicleAttributeContainer, StyledVinDecodeSection, StyledVinDivContainer } from '../VinDecodeComponent.style';
import { IntelligentPBEContainerComponent } from './IntelligentPBEContainerComponent';
import { IntelligentPhotoCaptureImageSection } from './IntelligentPhotoCaptureImageSection';
export const IntelligentEstimatorVinDecodeComponent = ({ appTheme, attachmentInfo, companyCode, contentType, contextId, hasVehicleResolved, selectedTileId, userVehicleInfo, vehicle, vehicleInfoData = new VehicleInfoState().vehicleInfoData, vehicleData, warningMessage, loadVehicleConfigurationAttributes, onUploadAttachments, onResetVehicleAction, onResetVehicleInfo, onViewChange, onVinUpdated, onValidVinData, onUpdateUserVehicleInfo, onSetOCRUserVerified }) => {
    const translateFn = TranslationService.translate;
    const [errorMessage, setErrorMessage] = React.useState(warningMessage);
    const assignmentSummaryHeaderText = getEstimatorSummaryHeaderText(userVehicleInfo !== null && userVehicleInfo !== void 0 ? userVehicleInfo : vehicle);
    const attachment = attachmentInfoUtilities.getAttachmentBySelectedTileId(attachmentInfo, selectedTileId);
    const vinText = attachmentInfoUtilities.getAttachmentTextByContentType(attachment, contentType);
    const imageSrc = React.useMemo(() => EnterpriseDocStoreService.createFileUrl((attachment === null || attachment === void 0 ? void 0 : attachment.fileId) || EMPTY_TEXT), [
        attachment
    ]);
    React.useEffect(() => {
        var _a, _b;
        if ((_a = attachment === null || attachment === void 0 ? void 0 : attachment.estimatorVehicleInfo) === null || _a === void 0 ? void 0 : _a.mitchellVid) {
            onValidVinData(vehicleInfoData, vinText, attachment.estimatorVehicleInfo.mitchellVid, (_b = attachment.estimatorVehicleInfo.serviceBarcode) === null || _b === void 0 ? void 0 : _b.toString(), true);
        }
        else {
            onVinUpdated(vinText, VehicleSelectionMethod.VinDecode);
        }
    }, []);
    React.useEffect(() => {
        if (vehicleInfoData && vehicleInfoData.Vin) {
            const isValidVin = OCR_previewScreen_RegEx_validator.VIN_DECODE_REGEX.test(vehicleInfoData.Vin);
            setErrorMessage(isValidVin ? EMPTY_TEXT : VIN_INVALID_MESSAGE);
            if (vehicleInfoData.Vin !== vinText) {
                onResetVehicleInfo(VehicleSelectionMethod.VinDecode, vehicleInfoData.Vin);
                onVinUpdated(vehicleInfoData.Vin, VehicleSelectionMethod.VinDecode);
                onResetVehicleAction();
            }
        }
    }, [vehicleInfoData.Vin]);
    React.useEffect(() => {
        setErrorMessage(warningMessage);
    }, [warningMessage]);
    React.useEffect(() => {
        if (hasVehicleResolved) {
            loadVehicleConfigurationAttributes((vehicleData === null || vehicleData === void 0 ? void 0 : vehicleData.vid) || 0, undefined);
        }
    }, [hasVehicleResolved]);
    const handleOnMoveNext = React.useCallback(() => {
        const mappedEstimatorVehicleInfo = vinDecode.mapVehicleInfoData(vehicleInfoData, vehicleData);
        if (!mappedEstimatorVehicleInfo) {
            onViewChange(IntelligentPhotoCaptureViewType.NONE);
            return;
        }
        const updatedAttachmentInfo = attachmentInfoUtilities.updateAttachmentOCRDetailsById(attachment, contentType, vehicleInfoData.Vin || vinText, mappedEstimatorVehicleInfo);
        if (updatedAttachmentInfo) {
            onUploadAttachments([[updatedAttachmentInfo]], contextId, companyCode);
            onSetOCRUserVerified(contentType);
        }
        onUpdateUserVehicleInfo(mappedEstimatorVehicleInfo);
        onViewChange(IntelligentPhotoCaptureViewType.NONE);
    }, [
        attachment,
        companyCode,
        contentType,
        contextId,
        onUploadAttachments,
        onViewChange,
        vehicleData,
        vehicleInfoData,
        vinText,
        onUpdateUserVehicleInfo,
        onSetOCRUserVerified
    ]);
    const handleOnMovePrevious = React.useCallback(() => {
        onResetVehicleInfo(VehicleSelectionMethod.VinDecode, EMPTY_TEXT);
        onViewChange(IntelligentPhotoCaptureViewType.NONE);
    }, [onResetVehicleInfo, onViewChange]);
    return (React.createElement(IntelligentPBEContainerComponent, { warningMessage: translateFn(errorMessage), islanguageHide: true, appTheme: appTheme, isFooter: true, hasMultipleButton: false, movePrevious: handleOnMovePrevious, moveNext: handleOnMoveNext, shouldShowAvatar: false, estimatorSummaryHeaderText: assignmentSummaryHeaderText, btnLabel: translateFn(IntelligentAssignmentSummary.DONE_BUTTON_LABEL), isBtnDisabled: !!errorMessage },
        React.createElement(StyledImageDiv, { container: true, id: `${IntelligentPhotoCaptureAddViewConstants.IMAGE_CONTAINER_BOX}` },
            React.createElement(IntelligentPhotoCaptureImageSection, { imageSrc: imageSrc })),
        React.createElement(StyledVinDecodeSection, null,
            React.createElement(StyledVinDivContainer, null,
                React.createElement(VehicleSelectionContainer, { isDisabled: false, shouldShowManualOption: false, t: TranslationService.translate })),
            React.createElement(StyledVehicleAttributeContainer, null,
                React.createElement(VehicleAttributeContainer, null)))));
};
//# sourceMappingURL=IntelligentEstimatorVinDecodeComponent.js.map